<template>
  <div ref="custom-table">
    <el-form
      ref="form"
      destroy-on-close="true"
      :model="form"
      :rules="rule ? rules : rules2"
    >
      <el-form-item>
        <div class="cityFlex">
          <el-form-item prop="provinceCode" style="width: 140px">
            <el-select
              ref="provinceCode"
              :disabled="display"
              style="width: 100%"
              v-model="form.provinceCode"
              placeholder="省份"
              @change="changeProvinceName"
              @click="clickpro"
            >
              <el-option
                v-for="item in form.AddressProvince"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>

          <el-form-item prop="cityCode" style="width: 140px">
            <el-select
              ref="cityCode"
              :disabled="display"
              style="width: 100%"
              v-model="form.cityCode"
              placeholder="城市"
              @change="changeCityName"
            >
              <el-option
                v-for="item in form.AddressCity"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            prop="value"
            style="width: 140px; margin-bottom: 0 !important"
          >
            <el-select
              ref="value"
              :disabled="display"
              style="width: 100%"
              v-model="form.value"
              placeholder="区（县）"
              @change="submit"
            >
              <el-option
                v-for="item in form.AddressTown"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import userApi from "../../../api/user.js";
export default {
  name: "city",
  props: ["rule", "subcirtArry"],
  data() {
    return {
      display: false,
      bj: false,
      rules2: {},
      rules: {
        provinceCode: [
          {
            required: true,
            message: "请选择地址",
            trigger: ["blur", "change"],
          },
        ],
        cityCode: [
          {
            required: true,
            message: "请选择地址",
            trigger: ["blur", "change"],
          },
        ],
        value: [
          {
            required: true,
            message: "请选择地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      form: {
        AddressCity: [],
        AddressProvince: [],
        AddressTown: [],
        provinceCode: "",
        cityCode: "",
        value: "",
      },
    };
  },

  created() {
    this.init();
    this.bj = false;
  },
  destroyed() {
    this.form = {
      AddressCity: [],
      AddressProvince: [],
      AddressTown: [],
      provinceCode: "",
      cityCode: "",
      value: "",
    };
  },
  methods: {
    restRule() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    clickpro(e) {
      console.log(e);
    },
    changeCityName() {
      console.log(2222, "-2222222222-----------");
      // 选择城市
      this.$emit("changeClear");
      this.form.value = "";
      this.findBycityCode();
    },
    changeProvinceName() {
      console.log("222");
      this.$emit("changeClear");
      //每当值省份值改变时其下地区值进行清空
      this.form.AddressCity = [];
      this.form.AddressTown = [];
      this.form.cityCode = "";
      this.form.value = "";
      this.findByprovinceCode();
    },
    // 赋值
    async sub(subobj) {
      await this.init();
      if (subobj.isdiplay) {
        this.$nextTick((res) => {
          this.display = true;
          this.form.provinceCode = subobj.province;
          this.form.cityCode = subobj.city;
          this.form.value = "-";
        });
        return;
      }
      // 这
      this.bj = true;
      this.form.provinceCode = subobj.pid;
      await this.findByprovinceCode();

      this.form.cityCode = subobj.cid;

      await this.findBycityCode(subobj.distinguishCode);
      // setTimeout(() => {
      //   this.form.value = subobj.distinguishCode;
      // }, 500);
    },
    // 筛选
    filterByName(itemd, ageid, idd) {
      return itemd.filter((item) => item[idd] == ageid)[0];
    },
    rest() {
      this.display = false;
      this.form = {
        AddressCity: [],
        AddressProvince: [],
        AddressTown: [],
        provinceCode: "",
        cityCode: "",
        value: "",
      };
      this.init();
      this.bj = false;
      // 清空
    },
    // 提交方法
    submit() {
      return new Promise((resolve, reject) => {
        if (this.display) {
          resolve(1);
          return;
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 当前选择的省
            let proItem = this.filterByName(
              this.form.AddressProvince,
              this.form.provinceCode,
              "key"
            );
            // 当前选择的市
            let cityItem = this.filterByName(
              this.form.AddressCity,
              this.form.cityCode,
              "key"
            );
            // 当前选择的区
            let valueItem = this.filterByName(
              this.form.AddressTown,
              this.form.value,
              "key"
            );
            let provinceId = proItem ? proItem.key : "";
            let cityId = cityItem ? cityItem.key : "";
            let countyId = valueItem ? valueItem.key : "";

            let arr = [
              {
                Code: this.form.provinceCode,
                Name: this.filterByName(
                  this.form.AddressProvince,
                  this.form.provinceCode,
                  "key"
                )
                  ? this.filterByName(
                      this.form.AddressProvince,
                      this.form.provinceCode,
                      "key"
                    ).value
                  : "",
              },
              {
                Code: this.form.cityCode,
                Name: this.filterByName(
                  this.form.AddressCity,
                  this.form.cityCode,
                  "key"
                )
                  ? this.filterByName(
                      this.form.AddressCity,
                      this.form.cityCode,
                      "key"
                    ).value
                  : "",
                Pid: this.filterByName(
                  this.form.AddressCity,
                  this.form.cityCode,
                  "key"
                )
                  ? this.filterByName(
                      this.form.AddressCity,
                      this.form.cityCode,
                      "key"
                    ).pid
                  : "",
              },
              {
                Code: this.form.value,
                Name: this.filterByName(
                  this.form.AddressTown,
                  this.form.value,
                  "key"
                )
                  ? this.filterByName(
                      this.form.AddressTown,
                      this.form.value,
                      "key"
                    ).value
                  : "",
                Cid: this.filterByName(
                  this.form.AddressTown,
                  this.form.value,
                  "key"
                )
                  ? this.filterByName(
                      this.form.AddressTown,
                      this.form.value,
                      "key"
                    ).cid
                  : "",
              },
              { cid: this.form.cityCode, pid: this.form.provinceCode },
              { provinceId: provinceId, cityId: cityId, countyId: countyId },
            ];

            console.log(arr, "zijiedianarr");
            this.$emit("submitt", arr);
            resolve(1);
            // return arr
          } else {
            this.$emit("submitt", "err");
            reject(0);
          }
        });
      });
    },
    async init() {
      //加载时发起请求获取所有省份值
      await userApi
        .getProvince()
        .then((res) => {
          if (res.code == 200) {
            this.form.AddressProvince = res.data;
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async findByprovinceCode() {
      //获取当前省份值pid，获取该省份下城市
      // return;
      console.log(this.form.AddressProvince, this.form.provinceCode, "key");
      await userApi
        .getCity({
          province: this.filterByName(
            this.form.AddressProvince,
            this.form.provinceCode,
            "key"
          ).value,
        })
        .then((res) => {
          if (res.code == 200) {
            this.form.AddressCity = res.data;
            // 解决赋值进来不刷新
            if (this.bj) {
              this.form.provinceCode = this.form.provinceCode;
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async findBycityCode(ee) {
      //获取当前城市值id，获取该城市下区域

      userApi
        .getCounty({
          city: this.filterByName(
            this.form.AddressCity,
            this.form.cityCode,
            "key"
          ).value,
          province: this.filterByName(
            this.form.AddressProvince,
            this.form.provinceCode,
            "key"
          ).value,
        })
        .then((res) => {
          if (res.code == 200) {
            this.form.AddressTown = res.data;
            // 解决赋值进来不刷新
            if (this.bj) {
              this.form.cityCode = this.form.cityCode;
              if (ee) {
                this.form.value = ee;
              }
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style  scoped>
.cityFlex {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/city.vue